import type { SavedCard } from '@dataTypes/payment.types'

import amexLogo from '@assets/images/CardLogos/amex.png'
import dinersLogo from '@assets/images/CardLogos/diners.png'
import discoverLogo from '@assets/images/CardLogos/discover.png'
import jcbLogo from '@assets/images/CardLogos/jcb.png'
import mastercardLogo from '@assets/images/CardLogos/mastercard.png'
import unionpayLogo from '@assets/images/CardLogos/unionpay.png'
import visaLogo from '@assets/images/CardLogos/visa.png'

const CARD_LOGOS: Record<Exclude<SavedCard['brand'], 'unknown'>, string> = {
  amex: amexLogo,
  diners: dinersLogo,
  discover: discoverLogo,
  jcb: jcbLogo,
  mastercard: mastercardLogo,
  unionpay: unionpayLogo,
  visa: visaLogo,
}

export function normalizeBrand(brand: string): SavedCard['brand'] {
  const b = brand?.toLowerCase().trim() ?? ''
  if (b === 'amex' || b === 'american express') return 'amex'
  if (b === 'visa') return 'visa'
  if (b === 'mastercard' || b === 'master card') return 'mastercard'
  if (b === 'diners' || b === 'diners club') return 'diners'
  if (b === 'discover') return 'discover'
  if (b === 'jcb') return 'jcb'
  if (b === 'unionpay' || b === 'union pay') return 'unionpay'
  return 'unknown'
}

export function getCardLogo(brand: string): string {
  const normalized = normalizeBrand(brand)
  if (normalized === 'unknown') {
    return mastercardLogo
  }
  return CARD_LOGOS[normalized]
}

/** Detect card brand from PAN digits (IIN / BIN prefixes). */
export function detectCardBrandFromNumber(value: string): SavedCard['brand'] {
  const digits = value.replace(/\D/g, '')

  if (!digits) {
    return 'unknown'
  }

  if (/^3[47]/.test(digits)) {
    return 'amex'
  }

  if (/^3(?:0[0-5]|09|[689])/.test(digits)) {
    return 'diners'
  }

  if (
    /^(6011|65|64[4-9])/.test(digits) ||
    /^622(?:1[2-9]|[2-8]\d|9[01])/.test(digits)
  ) {
    return 'discover'
  }

  if (/^35(?:2[89]|[3-8]\d)/.test(digits)) {
    return 'jcb'
  }

  if (/^62/.test(digits)) {
    return 'unionpay'
  }

  if (
    /^5[1-5]/.test(digits) ||
    /^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d{2}|7(?:[01]\d|20))/.test(digits)
  ) {
    return 'mastercard'
  }

  if (/^4/.test(digits)) {
    return 'visa'
  }

  return 'unknown'
}
